import React, { Component } from "react";
import { StateConsumerType } from "react-context-global-state";
import { State, StateConsumer } from "../state";
import DesktopHeader from "./DesktopHeader";
import "./header.scss";
import { withTranslation } from "react-i18next";

const DesktopHeaderTranslated = withTranslation()(DesktopHeader);

export default class Header extends Component {
  render() {
    const AuthenticationStateConsumer = StateConsumer as StateConsumerType<State, "fullscreen">;
    return <AuthenticationStateConsumer name="fullscreen">{(value) => (!value ? this.RenderMenu() : <span></span>)}</AuthenticationStateConsumer>;
  }

  private RenderMenu(): React.ReactNode {
      return <DesktopHeaderTranslated></DesktopHeaderTranslated>;
  }
}
